module.exports = __webpack_public_path__ + "img/norbit-logo.be2d23ed.svg";